
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/priser",
      function () {
        return require("private-next-pages/priser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/priser"])
      });
    }
  